// JsFromRoutes CacheKey 16d7f0681ab2f153544c256c9a6f9b2d
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_sections/search'),
  duplicate: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_sections/:id/duplicate'),
  typeaheadSelect: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_sections/typeahead_select'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_sections'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_sections'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/hero_sections/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/hero_sections/:id'),
}
